export const PRODUCT_INFO_TAB_SET_ACTIVE_TAB = 'PRODUCT_INFO_TAB_SET_ACTIVE_TAB';

export const setActiveTab = (tabName) => (dispatch) => {

    dispatch({
        type: PRODUCT_INFO_TAB_SET_ACTIVE_TAB,
        payload: {
            activeInfoTab: tabName,
        }
    });
   
}

export const setExplodedViewCount = (count) => (dispatch) => {

    dispatch({
        type: PRODUCT_INFO_TAB_SET_ACTIVE_TAB,
        payload: {
            explodedViewCount: parseInt(count) || 0,
        }
    });
   
}